import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Id")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Company name")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Business id")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Company logo URL")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Contact person name")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Contact person email")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Industry")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Reporting dimensions from SSO")
const _hoisted_9 = { class: "row q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_organizations_editable_field_company_name = _resolveComponent("organizations-editable-field-company-name")!
  const _component_organizations_editable_field_business_id = _resolveComponent("organizations-editable-field-business-id")!
  const _component_organizations_editable_field_logo_url = _resolveComponent("organizations-editable-field-logo-url")!
  const _component_organizations_editable_field_contact_person_name = _resolveComponent("organizations-editable-field-contact-person-name")!
  const _component_organizations_editable_field_contact_person_email = _resolveComponent("organizations-editable-field-contact-person-email")!
  const _component_organizations_editable_field_industry = _resolveComponent("organizations-editable-field-industry")!
  const _component_organizations_editable_field_reporting_dimensions_from_sso = _resolveComponent("organizations-editable-field-reporting-dimensions-from-sso")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_list, { class: "q-mb-lg" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.organization.id), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_organizations_editable_field_company_name, {
                  modelValue: _ctx.organizationModel.companyName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.organizationModel.companyName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_organizations_editable_field_business_id, {
                  modelValue: _ctx.organizationModel.businessId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.organizationModel.businessId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_organizations_editable_field_logo_url, {
                  modelValue: _ctx.organizationModel.logoUrl,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.organizationModel.logoUrl) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_organizations_editable_field_contact_person_name, {
                  modelValue: _ctx.organizationModel.contactName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.organizationModel.contactName) = $event)),
                  contactPersonEmail: _ctx.organization.contactEmail
                }, null, 8, ["modelValue", "contactPersonEmail"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_organizations_editable_field_contact_person_email, {
                  modelValue: _ctx.organizationModel.contactEmail,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.organizationModel.contactEmail) = $event)),
                  contactPersonName: _ctx.organization.contactName
                }, null, 8, ["modelValue", "contactPersonName"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_organizations_editable_field_industry, {
                  modelValue: _ctx.organizationModel.industryId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.organizationModel.industryId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_organizations_editable_field_reporting_dimensions_from_sso, {
                  modelValue: _ctx.organizationModel.ssoReportingDimensions,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.organizationModel.ssoReportingDimensions) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_separator, { class: "q-my-lg" }),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_q_btn, {
        label: "Go to List",
        color: "primary",
        onClick: _ctx.onGoToList,
        outline: "",
        unelevated: "",
        "no-caps": ""
      }, null, 8, ["onClick"]),
      _createVNode(_component_q_btn, {
        label: "Show Members",
        color: "secondary",
        onClick: _ctx.onShowMembers,
        unelevated: "",
        "no-caps": ""
      }, null, 8, ["onClick"])
    ])
  ], 64))
}